import { UnstyledButton, Loader, Center } from '@mantine/core'

const BUTTON_WIDTH = 224
const LOGO_SECTION_WIDTH = 40

export default function SocialLoginButton({ logo, logoAlt = '', children, onClick, loading, disabled }) {
    const isActive = !disabled && !loading

    return (
        <Center>
            <UnstyledButton
                className="socialLoginButton"
                onClick={onClick}
                disabled={disabled || loading}
                style={{
                    width: `${BUTTON_WIDTH}px`,
                    height: '40px',
                    display: 'flex',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    cursor: isActive ? 'pointer' : 'default',
                    flexShrink: 0,
                }}
            >
                {/* Logo section — 36×36 black square, logo centred */}
                <div className="socialLoginLogo" style={{
                    width: `${LOGO_SECTION_WIDTH}px`,
                    height: `${LOGO_SECTION_WIDTH}px`,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    {loading
                        ? <Loader size={16} color="white" type="oval" />
                        : <img src={logo} alt={logoAlt} style={{ width: '22px', height: '22px', objectFit: 'contain', display: 'block' }} />
                    }
                </div>

                {/* Text section */}
                <div className="socialLoginText" style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '21px',
                    paddingRight: '16px',
                    color: '#fff',
                    fontFamily: "'Google Sans', Roboto, arial, sans-serif",
                    fontSize: '14px',
                    fontWeight: 500,
                    letterSpacing: '0.25px',
                    whiteSpace: 'nowrap',
                }}>
                    {children}
                </div>
            </UnstyledButton>
        </Center>
    )
}
